import { render } from "./list-sub-dis.vue?vue&type=template&id=6b6f1da2&scoped=true&ts=true"
import script from "./list-sub-dis.vue?vue&type=script&lang=ts"
export * from "./list-sub-dis.vue?vue&type=script&lang=ts"

import "./list-sub-dis.vue?vue&type=style&index=0&id=6b6f1da2&lang=less&scoped=true"
import "./list-sub-dis.vue?vue&type=style&index=1&id=6b6f1da2&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6f1da2"]])

export default __exports__